<div class="wrapper">

  <div class="contentWrapper {{showingPopup ? 'blurredContent' : ''}}">

    <!-- header -->
    <div class="topContent">

      <div class="remainingSpace">
        <button
          [matTooltip]="backTooltipForSection(previousSectionTitle)"
          class="icon-button header-icon-button"
          (click)="onBack()"
          >
          <tun-arrow-back36px-icon-v5 class="icon icon-large-scaled-svg-button"></tun-arrow-back36px-icon-v5>
        </button>
      </div>

      <div class="titleContainer">

        <button
          [disabled]="!(hasTracks$ | async)"
          [matTooltip]="'trackOptions.list.playAll' | translate"
          class="icon-button first-title-item {{checkedTracks.length > 0 ? 'no-focus' : ''}}"
          (click)="onPlayAll()"
          >
          <tun-play-icon-v5 class="icon colored-icon"></tun-play-icon-v5>
        </button>

        <div class="title">
          <button
            [matTooltip]="backTooltipForSection('search.tab.label' | translate)"
            class="title-link-button"
            (click)="onBackToSearch()"
            >
            {{'search.tab.label' | translate }}:
          </button>

          @if (previousSectionTitle != null) {
            <button
              [matTooltip]="backTooltipForSection(previousSectionTitle)"
              class="title-link-button"
              (click)="onBack()"
              >
              {{previousSectionTitle}}:
            </button>
          }

          <button
            [disabled]="checkedTracks.length > 0"
            [matTooltip]="refreshTooltip()"
            class="title-link-button"
            (click)="onRefresh()"
            >
            {{title}}
            <tun-refresh-icon-v5 class="icon icon-small refresh-icon"></tun-refresh-icon-v5>
          </button>
        </div>



        <button
          [disabled]="!(hasTweaks$ | async) || checkedTracks.length > 0"
          [matTooltip]="((hasTweaks$ | async) ? 'trackOptions.list.tweak.adjust' : 'trackOptions.list.tweak.noTweaks') | translate"
          class="icon-button"
          (click)="onTweak()"
          >
          <tun-menu-music-channel-icon-v5 class="icon"></tun-menu-music-channel-icon-v5>
        </button>

      </div>

      <div class="remainingSpace"></div>

    </div>

    @if (musicCollection$ | async) {
      <!-- Special playlist states indicator -->
      @if (searchState != SearchState.normal) {
        <div
          class="feedback-container"
          >
          @switch (searchState) {
            @case (SearchState.searchError) {
              <div
                class="error-feedback-container"
                >
                <p>
                  {{'search.status.failed' | translate }}
                </p>
                <button (click)="retryClick()" class="retryButton">
                  <p>
                    {{'general.tryAgain' | translate }}
                  </p>
                </button>
              </div>
            }
            @case (SearchState.searching) {
              <tun-loader-v5 class="loader"></tun-loader-v5>
            }
          }
        </div>
      }
      @if (searchState == SearchState.normal) {
        <tun-selectable-track-list-view
          class="trackTable"
          [tracks]="tracks$ | async"
          [checkedTracks]="checkedTracks"
          [audioFileProperty]="audioFileProperty$ | async"
          (checkedTracksChanged)="onCheckedTracksChanged($event)"
          (addTracksToPlaylist)="onAddTracksToPlaylist($event)"
          (showOptions)="onShowOptions($event)"
          >
        </tun-selectable-track-list-view>
      }
    }


  </div>


  <!-- Popup: choose playlist-->
  @if (showChoosePlaylistOverlay) {
    <div #choosePlaylistPopupWrapper class="popupWrapper" @slideUpAnimation (click)="onClickOutside($event, choosePlaylistPopupWrapper)">
      <tun-overlay-add-songs-to-playlist
        class="overlay-panel"
        [tracks]="checkedTracks"
        (close)="onCloseAddTracksToPlaylist($event)"
        >
      </tun-overlay-add-songs-to-playlist>
    </div>
  }

  <!-- Popup: tweak musicCollection -->
  @if (showTweakPopup) {
    <div #tweakPopupWrapper class="popupWrapper" @slideUpAnimation (mousedown)="onClickOutside($event, tweakPopupWrapper)">
      <tun-overlay-tweak-music-collection
        class="overlay-panel"
        [musicChannel]="showingMusicChannel$ | async"
        [musicCollection]="musicCollection$ | async"
        (parametersChanged)="onParametersChanged($event)"
        (close)="onCloseTweakPopup()"
        >
      </tun-overlay-tweak-music-collection>
    </div>
  }



</div>

